/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../../types/QueryTags'

import { 
  GetTenureRequest, 
  GetTenureResponse,
  CheckEligibilityRequest,
  CheckEligibilityResponse,
  RegisterBkQuickRequest,
  RegisterBkQuickResponse,
  ApplyForBkQuickRequest,
  ApplyForBkQuickResponse
} from './types'


import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'


const basePath = 'loan-management'

const BkQuickEndpoints = (builder: EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) => 
  ({
    getTenure: builder.query<GetTenureResponse, GetTenureRequest> ({
      query: () => `${basePath}/loans/tenures/bkquick`
    }),
    checkEligibility: builder.mutation<CheckEligibilityResponse, CheckEligibilityRequest>({
      query: (body) => {
        return ({
          url:`${basePath}/loans/bkquick/eligibility`,
          method: 'POST',
          body,
        })
      }
    }),
    registerForBkQuick: builder.mutation<RegisterBkQuickResponse, RegisterBkQuickRequest>({
      query: (body) => {
        return ({
          url:`${basePath}/loans/bkquick/register`,
          method: 'POST',
          body,
        })
      }
    }),
    applyForBkQuick: builder.mutation<ApplyForBkQuickResponse, ApplyForBkQuickRequest>({
      query: (body) => {
        return ({
          url:`${basePath}/loans/bkquick/apply`,
          method: 'POST',
          body,
        })
      }
    }),
  })
  
export default BkQuickEndpoints